import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

/**
 *
 *
 * @returns any OK
 */
export function getV1SmartthermostatGeneratedswagger(requestConfig: ApiRequestConfig = {}): Promise<any> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/generatedswagger`,
    },
    requestConfig,
  );
}
